// swap portal resource page logic
document.addEventListener("DOMContentLoaded", function () {
  const portalNavItems = document.querySelectorAll(
    ".portal-side-navigation__nav--item-wrapper"
  );

  const mobilePortalNav = document.querySelector(
    ".portal-side-navigation__nav--wrapper"
  );

  const mobileCurrentNavItem = document.querySelector(".current-title");

  let currentPage = "overview";

  const toggleMobileMenu = () => {
    if (mobilePortalNav.classList.contains("closed")) {
      mobilePortalNav.classList.remove("closed");
    } else {
      mobilePortalNav.classList.add("closed");
    }
  };

  portalNavItems?.forEach((item) => {
    if (item.classList.contains("mobile-current-nav-item")) {
      item.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          toggleMobileMenu();
        }
      });

      item.addEventListener("click", (e) => {
        toggleMobileMenu();
      });
    } else {
      const swapPage = (e) => {
        const postId = item.dataset.postId;
        const title = e.target.querySelector(".current-title");

        if (postId?.toString() !== currentPage?.toString()) {
          mobilePortalNav.classList.add("closed");
          const previousNavItem = document.querySelector(".current-nav-item");
          previousNavItem.classList.remove("current-nav-item");

          mobileCurrentNavItem.innerHTML = title.innerHTML;

          item.classList.add("current-nav-item");

          const previousPage = document.querySelector(
            `[data-page-id="${currentPage}"]`
          );
          previousPage.classList.remove("current");

          currentPage = postId;

          const selectedPage = document.querySelector(
            `[data-page-id="${postId}"]`
          );
          selectedPage.classList.add("current");
        }
      };
      item.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          swapPage(e);
        }
      });

      item.addEventListener("click", (e) => {
        swapPage(e);
      });
    }
  });
});
